import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { ReportFilter } from '../../ReportFilter'
import { ReportFilterStore } from '../../ReportFilterStore'
import { PurchaseOrderCount } from './PurchaseOrderCount'
import { Products } from './Products'
import { Vendors } from './Vendors'
import { Taxes } from './Taxes'
import Helmet from 'react-helmet'

interface Props {
  companyId: number
  reportFilterStore?: ReportFilterStore
}

@inject('reportFilterStore')
@observer
export class PurchaseOrderReport extends React.Component<Props, {}> {
  constructor(props: Props) {
    super(props)
  }

  render() {
    return (
      <>
        <Helmet>
          <title>Reports | Purchase Orders</title>
          <meta name='page-loaded' content='true' />
        </Helmet>

        <ReportFilter />

        <div className='row'>
          <div className='col-lg-4'>
            <PurchaseOrderCount companyId={this.props.companyId} />
            <br />
            <Vendors companyId={this.props.companyId} />
            <br />
            <Taxes companyId={this.props.companyId} />
            <br />
          </div>
          <div className='col-lg-8'>
            <Products companyId={this.props.companyId} />
            <br />
          </div>
        </div>
      </>
    )
  }
}
